import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../components/Home/Home';
import ToolPage from '../components/Tools/ToolPage';
import About from '../components/Pages/About';
import Contact from '../components/Pages/Contact';
import Blog from '../components/Pages/Blog';
import BlogDetail from '../components/Pages/BlogDetail';
import Login from '../components/Admin/Login/Login';
import AdminLayout from '../components/Admin/Layout/AdminLayout';
import BlogManager from '../components/Admin/Blog/BlogManager';
import ProtectedRoute from '../components/Admin/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:id" element={<BlogDetail />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin/blog"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <BlogManager />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route path="/tools/loader" element={<ToolPage toolType="loader" />} />
      <Route path="/tools/gradient" element={<ToolPage toolType="gradient" />} />
      <Route path="/tools/card" element={<ToolPage toolType="card" />} />
      <Route path="/tools/animation" element={<ToolPage toolType="animation" />} />
      <Route path="/tools/alert" element={<ToolPage toolType="alert" />} />
      <Route path="/tools/photo-picker" element={<ToolPage toolType="photoPicker" />} />
      <Route path="/tools/json-to-model" element={<ToolPage toolType="jsonToModel" />} />
      <Route path="/tools/api-generator" element={<ToolPage toolType="apiGenerator" />} />
      {/* Storyboard → SwiftUI converter route temporarily disabled from public navigation */}
      {/* <Route path="/tools/storyboard-converter" element={<ToolPage toolType="storyboardToSwiftUI" />} /> */}
      <Route path="/tools/postman-importer" element={<ToolPage toolType="postmanImporter" />} />
    </Routes>
  );
};

export default AppRoutes;

